import { render, staticRenderFns } from "./blayer.vue?vue&type=template&id=64fe7421&scoped=true"
import script from "./blayer.vue?vue&type=script&lang=js"
export * from "./blayer.vue?vue&type=script&lang=js"
import style0 from "./blayer.vue?vue&type=style&index=0&id=64fe7421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe7421",
  null
  
)

export default component.exports